<template>
    <el-dialog
        title="添加IMEI"
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form >
          <el-form-item label="IMEI:" prop="IMEI" label-width="100px">
              <el-input  v-model="form.imei"  autocomplete="off"></el-input>
        </el-form-item>
            <div class="buttom-box">
                    <el-button type="primary" @click="AddClick()">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { studentRfidAdd} from '@/assets/api/schoollog'
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    props: ['Deviceidobj'],
    data() {

        return {
            dialogVisible: true,
            title:'',
            form:{
                imei:'',
            },
            cardid:"",
            schoolList:[],
          
        }

    },
    created(){
       
    },
    mounted(){
        
    },
    methods:{
        handleClose() {
            this.$emit('BindingShow')
      },
      AddClick(){
        this.deviceClick()
    },
    deviceClick(){
        console.log(this.Deviceidobj,'11111111111111');
        // const params = {
            //     rfid:this.form.rfid,
            //     studentId:this.Deviceidobj.studentId
            // }
        studentRfidAdd(this.form.imei,this.Deviceidobj.studentId).then((res)=> {
                console.log(res,'成功');
                this.handleClose()
        }).catch((err) => {
            this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
        })
      }

    }
    }




</script>
<style  scoped lang="scss">
    /deep/ {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        margin-left: 180px;

    }
    
    .el-form-item--small{
        width: 70% !important;
    }
    }
</style>